import { createSlice } from "@reduxjs/toolkit";

export const sellerAuthSlice = createSlice({
  name: "sellerAuth",
  initialState: {
    user: null,
    accessToken: null,
    accessType: null,
    loginDate: null,
    redirectUrl: null,
    teams: null,
  },

  reducers: {
    setSellerUser: (state, action) => {
      state.user = action.payload;
    },

    setSellerTokens: (state, action) => {
      state.accessToken = action.payload.access_token;
    },

    setSellerAccessType: (state, action) => {
      state.accessType = action.payload.access_type;
    },

    setSellerLoginDate: (state, action) => {
      state.loginDate = action.payload.loginDate;
    },

    setSellerRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },

    setSellerTeams: (state, action) => {
      state.teams = action.payload;
    },

    clearSellerRedirectUrl: (state) => {
      state.redirectUrl = null;
    },

    clearSellerAuth: (state) => {
      state.user = null;
      state.accessToken = null;
      state.loginDate = null;
      state.redirectUrl = null;
      state.accessType = null;
      state.teams = null;
    },
  },
});

export const {
  setSellerUser,
  setSellerTokens,
  setSellerAccessType,
  setSellerLoginDate,
  setSellerRedirectUrl,
  setSellerTeams,
  clearSellerRedirectUrl,
  clearSellerAuth,
} = sellerAuthSlice.actions;

export default sellerAuthSlice.reducer;
